"use client";

import { useQuery } from "@tanstack/react-query";
import { getPlans, type Plan } from "@/api/subscription.service";
import { useTranslation } from "react-i18next";

// Query keys
export const PLANS_QUERY_KEY = ["plans"];

export function usePlans() {
  const { i18n } = useTranslation();
  
  return useQuery({
    queryKey: [...PLANS_QUERY_KEY, i18n.language],
    queryFn: () => getPlans(i18n.language),
    staleTime: 1000 * 60 * 60, // 1 hour
    refetchOnWindowFocus: false,
  });
}
